<atom-modal-wrapper [modalId]="modalId" size="xl" [modalTemplate]="dynamicForm">
    <ng-template #dynamicForm>
        <organism-modal
            [modalTitle]="
                isLoading
                    ? 'Loading...'
                    : (formTitle | translateTokenisedString)
            "
        >
            <atom-async-data
                [isLoading]="isLoading"
                [throbberContainerStyle]="false"
            >
                @if (formId) {
                    <wdx-ff-form-container
                        [formTemplateId]="formTemplateId"
                        [formTemplateEntityId]="formTemplateEntityId"
                        [formTemplateEntityType]="formTemplateEntityType"
                        [formId]="formId"
                        [entityId]="entityId"
                        [appId]="appId"
                        [initialisationParams]="initialisationParams"
                        [queryParams]="queryParams"
                        [emitInsteadOfPost]="emitInsteadOfPost"
                        [emitData]="emitData"
                        [customEndpoint]="customEndpoint"
                        [readonlyMode]="readonlyMode"
                        [auditMode]="auditMode"
                        [formConfig]="formConfig"
                        [dataOverrides]="dataOverrides"
                        [correlationId]="correlationId"
                        (formTitleReceived)="onFormTitleReceived($event)"
                        (formEvent)="formEvent($event)"
                    ></wdx-ff-form-container>
                }

                @if (!formId) {
                    <atom-feature-svg
                        class="d-block"
                        size="lg"
                        [svg]="FEATURE_SVG.AccessDenied"
                    >
                        <h5 class="mb-2">We were unable to locate your form</h5>
                        <div>Please contact your system administrator</div>
                    </atom-feature-svg>
                }
            </atom-async-data>
        </organism-modal>
    </ng-template>
</atom-modal-wrapper>
